import { EnvironmentProviders, inject, makeEnvironmentProviders } from '@angular/core';
import { HONOR_DENIAL } from '@telespot/shared/session-recorder';
import { AuthService } from '@telespot/web-core';
import { distinctUntilChanged, map } from 'rxjs/operators';

/**
 * Refusing the performance cookie stops the session recording for admins only: every other
 * signed-in user is recorded whether they accepted or not. A viewer whose role is not known yet —
 * nobody signed in — is honored, so an admin is never recorded before their role arrives.
 *
 * Product decision, not a technical one; see the PR that introduced it.
 */
export function provideAdminOnlyDenials(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: HONOR_DENIAL,
      useFactory: () =>
        inject(AuthService).currentUser$.pipe(
          map((user) => !user || !!user.isAdmin),
          distinctUntilChanged()
        ),
    },
  ]);
}
